import React, { useRef, useState } from "react";
import Style from "./DeliveryTable.module.scss";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Check2, PencilSquare, Wallet, XLg } from "react-bootstrap-icons";

const DeliveryTable = ({ showAddress, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
      width: "16%",
      ...getColumnSearchProps("name", "نام "),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showAddress(3, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "آیدی پیک",
      dataIndex: "key",
      key: "key",
      width: "16%",
      ...getColumnSearchProps("key", "آیدی پیک "),
    },
    {
      title: "شماره تلفن",
      dataIndex: "phone",
      key: "phone",
      width: "16%",
      ...getColumnSearchProps("phone", "شماره تلفن"),
    },
    {
      title: "زمان ثبت نام",
      dataIndex: "signUpDate",
      key: "signUpDate",
      width: "17%",
    },
    {
      title: "تعداد سفارش",
      dataIndex: "totalOrder",
      key: "totalOrder",
      width: "17%",
    },
    {
      title: "موجودی حساب",
      dataIndex: "money",
      key: "money",
      width: "17%",
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      width: "14%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => showAddress(1, record)}
            className={Style.editBtn}
          >
            <PencilSquare />
          </button>
          <button
            onClick={() => showAddress(4, record)}
            className={Style.shabaBtn}
          >
            شبا
          </button>
          {record.status === "1" ? (
            <button
              onClick={() => showAddress(2, record)}
              className={Style.deleteBtn}
            >
              <XLg />
            </button>
          ) : (
            <button
              onClick={() => showAddress(2, record)}
              className={Style.activeBtn}
            >
              <Check2 />
            </button>
          )}
          <button
            onClick={() => showAddress(5, record)}
            className={Style.walletBtn}
          >
            <Wallet />
          </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={data}
        responsive={true}
        scroll={{x:1500, y: 300 }}
      />
    </div>
  );
};

export default DeliveryTable;
